import { render } from "./UserPopCard.vue?vue&type=template&id=7d3a4121&scoped=true"
import script from "./UserPopCard.vue?vue&type=script&lang=js"
export * from "./UserPopCard.vue?vue&type=script&lang=js"

import "./UserPopCard.vue?vue&type=style&index=0&id=7d3a4121&lang=scss&scoped=true"

import exportComponent from "/Users/apple/Documents/xxiwant/lovestory/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-7d3a4121"]])

export default __exports__